import { createSelector } from 'reselect';

export const getLogin = state => state.login;

export const getRepresentedLocations = createSelector(
  [getLogin],
  login => {
    return login?.loggedIn && login.data 
      ? login.data.represents 
      : null;
  }
);
